export default __webpack_public_path__ + "static/media/up.09e890aa.svg";